@if (isVisible) {
<div class="custom-message" data-testid="custom-message-container" [class]="type">
   <div class="content-container">
      <div class="icon">
         @if (isErrorMessage) {
            <telenet-icon data-testid="custom-message-icon-error" [class]="type" name="error"></telenet-icon>
         }
         @if (isInfoMessage || isWarningMessage) {
            <telenet-icon data-testid="custom-message-icon-info" [class]="type" name="information"></telenet-icon>
         }
         @if (isSuccessMessage) {
            <telenet-icon data-testid="custom-message-icon-success" [class]="type" name="success"></telenet-icon>
         }
      </div>
      <div class="content">
         @if (title) {
            <div class="content-title" data-testid="custom-message-text-title">{{title}}</div>
         }
         <div class="content-text" data-testid="custom-message-text-content" [innerHTML]="message"></div>
      </div>
   </div>
   @if (canHide) {
   <div class="dismiss" data-testid="custom-message-btn-hide" (click)="hide()">
      <telenet-icon [name]="hideIcon"></telenet-icon>
   </div>
   }
</div>
}